export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 127%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.playSvgFill)+'" d="M.079 0L0 14l10.5-7.181z"/> </svg></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/play/templates/playIcon.dot
// module id = 214
// module chunks = 0 1 2 3 4